// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__j6aCO","subTitle":"Menu_subTitle__gJrk3","subtitleIcon":"Menu_subtitleIcon__BYfj2","link":"Menu_link__4b1r9","menu":"Menu_menu__QEyf7"};